
import { defineComponent } from "vue";
import * as api from "../api/apt";

export default defineComponent({
  data() {
    return {
      tabledata: [],
      pageSize: 30,
      currentPage: 1,
      title: "",
    };
  },

  methods: {
    getPreApp(id) {
      // if(sessionStorage.getItem('category') != null){
      //     let category = sessionStorage.getItem('category')
      //     api.getPresetApp(category)
      // }

      api.getPresetApp(id).then((res) => {
        // console.log(res)
        this.tabledata = res.data.result.results;
        // console.log(this.tabledata)
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
  },

  mounted() {
    let id = sessionStorage.getItem("category");
    let title = sessionStorage.getItem("title");
    if (title) {
      this.title = title;
    }
    this.getPreApp(id);
    // console.log(sessionStorage.getItem('category'))
  },
});
